import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function UserLoveFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M12.75 16.639C12.75 15.1053 13.8687 13.7501 15.5 13.7501C16.0855 13.7501 16.6247 13.8787 17.0953 14.1732C17.2418 14.2649 17.3764 14.3694 17.5 14.4851C17.6236 14.3694 17.7582 14.2649 17.9047 14.1732C18.3753 13.8787 18.9145 13.7501 19.5 13.7501C21.1313 13.7501 22.25 15.1053 22.25 16.639C22.25 18.4837 21.0327 19.8905 19.9821 20.7721C19.4504 21.2184 18.254 21.9224 17.835 22.169L17.8152 22.1807C17.6153 22.2733 17.3843 22.2731 17.1843 22.1804L17.165 22.1691C16.7464 21.9228 15.5498 21.2185 15.0179 20.7721C13.9673 19.8905 12.75 18.4837 12.75 16.639Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 16.6389C11.5 15.1298 12.3021 13.6646 13.6455 12.9508C12.9212 12.4913 12.1155 12.1488 11.2549 11.9495C13.2914 11.2274 14.75 9.28405 14.75 7C14.75 4.10051 12.3995 1.75 9.5 1.75C6.6005 1.75 4.25 4.10051 4.25 7C4.25 9.28405 5.70857 11.2274 7.7451 11.9495C4.31022 12.7447 1.75 15.8234 1.75 19.5C1.75 19.9142 2.08579 20.25 2.5 20.25H12.7905C12.0806 19.3117 11.5 18.1015 11.5 16.6389Z"
				fill="currentColor"
			/>
		</svg>
	);
}

UserLoveFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default UserLoveFilledIcon;
